import DeviceConfig from "@/components/Elemnt/DeviceConfig";
import { useParams } from "react-router";

function DeviceConfigPage() {
  const { appToken = "" } = useParams();
  return <DeviceConfig appToken={appToken} />;
}

export default DeviceConfigPage;
